import axios from "../../axios";

const api = {
  createScopeOne({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/emission-based/${questionnaireId}/scope-one`, data, headers)
      .then(({ data }) => data);
  },

  updateScopeOne({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/emission-based/${questionnaireId}/scope-one/${id}`, data, headers)
      .then(({ data }) => data);
  }
}

export default api;